import { buildability } from './vehicleConfiguration';

export const checkVehicleConfigurationBuildabilityQuery = `
  query checkVehicleConfigurationBuildability($configId: String!) {
    checkVehicleConfigurationBuildability(configId: $configId) {
      ${buildability}
    }
  }
`;
